module.exports = __webpack_public_path__ + "img/noDate.31b37b28.png";